import { Injectable } from '@angular/core';
import { BasketNotificationLoaderService } from '@auth/components/notification-menu/services/basket-notification-loader.service';

@Injectable()
export class BasketNotificationLoaderTxml5Service extends BasketNotificationLoaderService {
}
